<template>
  <div class="relative mb-2">
    <label :for="inputId">
      <span>{{ inputLabel }} <span v-if="inputRequired" class="text-orange-dark">*</span></span>
    </label>
    <div class="relative flex items-center">
      <input
        @focus="$emit('inputFocused')"
        @blur="$emit('inputBlured')"
        @paste="$emit('pasteEvent', innerValue)"
        :id="inputId"
        :name="inputName"
        :disabled="disabled"
        :type="inputType"
        :title="inputTitle"
        :tabindex="inputTabindex"
        v-model="innerValue"
        :required="inputRequired"
        :autofocus="inputAutofocus ? 'autofocus' : null"
        class="mb-0"
        :class="{
          '--large sm:max-w-11rem': inputLarge,
          '--passwordShowToggle': showPasswordButton,
        }"
        :maxlength="inputMaxlength" />
      <PasswordToggleButton
        v-if="showPasswordButton"
        @toggleClick="$emit('showPasswordToggle')"
        :showPassword="showPassword" />
    </div>
    <p v-if="inputInstructions" class="text-grey-darker dark:text-grey italic"><small>{{ inputInstructions }}</small></p>
    <p v-if="error" class="text-red text-xs font-semibold">{{ error }}</p>
  </div>
</template>

<script>
import PasswordToggleButton from './PasswordToggleButton.vue';

/**
 * TextInput
 * @component
 */
export default {
  name: 'TextInput',
  components: {
    PasswordToggleButton,
  },
  props: {
    value: {
      type: String,
      required: false,
    },
    inputId: {
      type: String,
      required: true,
    },
    inputInstructions: {
      type: String,
      required: false,
    },
    inputLabel: {
      type: String,
      required: true,
    },
    inputName: {
      type: String,
      required: true,
    },
    inputRequired: {
      type: Boolean,
      default: true,
    },
    inputAutofocus: {
      type: Boolean,
      default: false,
    },
    inputType: {
      type: String,
      required: false,
      default: 'text',
    },
    inputTitle: {
      type: String,
      required: false,
    },
    inputTabindex: {
      type: Number,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
    inputLarge: {
      type: Boolean,
      default: false,
    },
    inputMaxlength: {
      type: Number,
      required: false,
    },
    showPasswordButton: {
      type: Boolean,
      default: false,
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
